import React from "react";
import {
    NavLink, useHistory,
    useLocation
} from "react-router-dom";
import {getAuth, signInWithEmailAndPassword} from 'firebase/auth'
// Chakra imports
import {
    Box,
    Button,
    Checkbox,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    Icon,
    Input,
    InputGroup,
    InputRightElement,
    useColorModeValue,
    Text, Image,
} from "@chakra-ui/react";
// Assets
import {MdOutlineRemoveRedEye} from "react-icons/md";
import {RiEyeCloseLine} from "react-icons/ri";

// Custom components
import CenteredAuth from "layouts/auth/types/Centered";
import tacitLogoMedium from "../../../assets/img/logo/logo_379px.png";

function SignIn() {
    // Chakra color mode
    const textColor = useColorModeValue("type.1", "white");
    const textColorSecondary = "type.1";
    const textColorDetails = useColorModeValue("navy.700", "secondaryGray.600");
    const textColorBrand = useColorModeValue("#F46818", "white");
    const brandStars = useColorModeValue("brand.500", "brand.400");
    const incorrectPassword = useColorModeValue("red.500", "red.200");
    let history = useHistory();
    let location = useLocation();

    // eslint-disable-next-line no-unused-vars
    const handleLogin = async () => {


        let {from} = location.state || {from: {pathname: "/home"}};
        const authentication = getAuth();
        signInWithEmailAndPassword(authentication, email, password)
            .then((response) => {
                console.log("from", from);
                history.replace(from);
            })
            .catch(() => {
                setIncorrectPass(true);
            })

    }


    const [show, setShow] = React.useState(false);
    const handleClick = () => setShow(!show);
    let [email, setEmail] = React.useState('');
    let [password, setPassword] = React.useState('');
    let [incorrectPass, setIncorrectPass] = React.useState(false);

    return (
        <CenteredAuth
            //cardTop={{base: "auto", md: "auto"}}
            //cardBottom={{base: "auto", lg: "auto"}}
            >

            <Flex

                w='100%'
                mx={{base: "auto", lg: "0px"}}
                me='auto'
                justifyContent='center'
                px={{base: "20px", md: "0px"}}
                flexDirection='column'
                >
                <Flex me='auto'>
                    <Heading color={textColor} fontSize='36px' mb='20px'>
                        Sign-In
                    </Heading>
                </Flex>
                <Flex
                    zIndex='2'
                    direction='column'
                    w={{base: "100%", md: "400px"}}
                    maxW='100%'
                    background='transparent'
                    borderRadius='10px'
                    mx={{base: "auto", lg: "auto"}}
                    me='auto'
                    mb={{base: "auto", md: "auto"}}>
                    <form onSubmit={e => {
                        e.preventDefault();
                        handleLogin();
                    }}>
                        <FormLabel
                            display='flex'
                            ms='0px'
                            mb='0px'
                            fontWeight={'500'}
                            >
                            Email
                        </FormLabel>
                        <Input
                            variant='auth'
                            ms={{base: "0px", md: "0px"}}
                            type='email'
                            placeholder='mail@example.com'
                            mb='20px'
                            borderRadius='10px'
                            bg='backgroundS.l'

                            size='lg'
                            value={email}
                            onChange={event => setEmail(event.currentTarget.value)}
                        />
                        <FormLabel
                            fontWeight='500'
                            mb='0px'
                            display='flex'
                            >
                            Password
                        </FormLabel>
                        <InputGroup size='md'>
                            <Input
                                ms={{base: "0px", md: "0px"}}
                                placeholder='Min. 8 characters'
                                borderRadius='10px'
                                bg='backgroundS.l'
                                size='lg'
                                type={show ? "text" : "password"}
                                variant='auth'
                                value={password}
                                onChange={event => setPassword(event.currentTarget.value)}
                            />
                            <InputRightElement display='flex' alignItems='center' mt='4px'>
                                <Icon
                                    color={textColorSecondary}
                                    _hover={{cursor: "pointer"}}
                                    as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                                    onClick={handleClick}
                                />
                            </InputRightElement>
                        </InputGroup>
                        <Flex justify='end' mt='10px' mb='50px'>

                            <NavLink to='/auth/forgot-password'>
                                <Text
                                    color={textColorBrand}
                                    w='100%'

                                    fontWeight='500'>
                                    Forgot password?
                                </Text>
                            </NavLink>
                        </Flex>
                        {incorrectPass &&
                            <Text
                                color={incorrectPassword}
                                fontSize='md'
                                fontWeight='500'
                                textAlign={'center'}
                                h='30px'
                                mt='-30px'
                            >
                                Incorrect username or password
                            </Text>
                        }

                        <Button
                            bgColor="#F46818"
                            fontWeight='600'
                            borderRadius='10px'
                            color="#FFFFFFf6"
                            w='100%'
                            h='50'
                            type='submit'
                            onClick={() => handleLogin()}>
                            Sign-in

                        </Button>
                    </form>
                </Flex>
            </Flex>
        </CenteredAuth>
    );
}

export default SignIn;
